import swal from 'sweetalert2';

export default {
  data() {
    return {
      alertSettings: {
        title: 'Se eliminará la fila',
        text: '¿Desea proceder?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        cancelButtonText: 'Cancelar',
      },
      alertSuccessSettings: {
        title: 'Listo!',
        message: 'La fila ha sido eliminada',
      },
      resourceName: null,
      arrayDataName: 'tableData',
    };
  },
  methods: {
    deleteRow(id) {
      swal(this.alertSettings).then((result) => {
        if (result.value) {
          this.$services
            .resource(this.resourceName)
            .delete(id)
            .then(() => {
              return this[this.arrayDataName].splice(
                this[this.arrayDataName].findIndex((e) => e.id === id),
                1
              );
            })
            .then(() => {
              swal(this.alertSuccessSettings.title, this.alertSuccessSettings.message, 'success');
            });
        }
      });
    },
  },
};
